/**
 * oh-shipping-cta.js
 * ---------------------------------------------------------------------------
 * Schreibt nach erfolgreichem Add-to-Cart eine Versand-Meldung in den
 * ATC-Button (statt einer separaten Free-Shipping-Leiste).
 *
 * Ablauf:
 *   1. "variant:add" (vom <product-form>, bubbelt) -> Meldung in den Button.
 *   2. Cart-Drawer oeffnet sich (bestehendes Theme-Verhalten).
 *   3. Drawer schliesst ("dialog:after-hide" vom <cart-drawer>) -> nach 3 s
 *      zurueck zum Original-Text ("In den Warenkorb").
 *
 * Regeln (per data-Attribut aus buy-buttons.liquid):
 *   - nicht DE ODER Gong-Produkt           -> data-msg-added   ("Gute Wahl")
 *   - DE & qualifiziert & Summe >= Schwelle -> data-msg-reached ("Gratis Versand erreicht")
 *   - sonst                                -> data-msg-remaining ("Noch X bis gratis Versand")
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var REVERT_DELAY = 3000; // ms nach Drawer-Schliessen
  var LOADING_MS = 500;    // kurze Lade-Animation beim Zuruecksetzen
  var activeLabel = null;
  var revertTimer = null;

  function formatEuro(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Math.ceil(cents / 100));
  }

  // Versandpflichtige Summe minus Warenkorb-Rabatte (wie FreeShippingBar)
  function shippableTotal(cart) {
    var items = (cart && cart.items) || [];
    var sum = items.reduce(function (acc, item) {
      return item.requires_shipping ? acc + item.final_line_price : acc;
    }, 0);
    var discounts = (cart && cart.cart_level_discount_applications) || [];
    var discount = discounts.reduce(function (acc, d) {
      return acc + (d.total_allocated_amount || 0);
    }, 0);
    return sum - discount;
  }

  function messageFor(wrapper, cart) {
    var added = wrapper.getAttribute('data-msg-added') || '';
    var isDe = wrapper.getAttribute('data-is-de') === 'true';
    var isGong = wrapper.getAttribute('data-is-gong') === 'true';
    if (!isDe || isGong) return added;

    var threshold = parseFloat(wrapper.getAttribute('data-threshold')) || 0;
    if (threshold <= 0) return added;

    var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var thresholdCents = Math.round(threshold * 100 * rate);
    var total = shippableTotal(cart);

    if (total >= thresholdCents) {
      return wrapper.getAttribute('data-msg-reached') || added;
    }

    var template = wrapper.getAttribute('data-msg-remaining') || '';
    return template.replace(/\{\{.*?\}\}/, formatEuro(thresholdCents - total));
  }

  function showMessage(label, text) {
    // Original-Text einmalig sichern, dann ueberschreiben
    if (label.dataset.ohOriginal === undefined) {
      label.dataset.ohOriginal = label.textContent;
    }
    label.textContent = text;
    activeLabel = label;
    if (revertTimer) {
      clearTimeout(revertTimer);
      revertTimer = null;
    }
  }

  // Zuruecksetzen mit gleicher Animation wie beim Eintreten:
  // kurz "laden" (aria-busy -> Loader-Punkte) -> Text tauschen -> Original animiert wieder rein
  function revertWithAnimation(label) {
    var button = label.closest('button');
    if (!button) {
      if (label.dataset.ohOriginal !== undefined) label.textContent = label.dataset.ohOriginal;
      return;
    }
    button.setAttribute('aria-busy', 'true');
    setTimeout(function () {
      if (label.dataset.ohOriginal !== undefined) {
        label.textContent = label.dataset.ohOriginal;
      }
      button.removeAttribute('aria-busy');
    }, LOADING_MS);
  }

  function scheduleRevert() {
    if (!activeLabel) return;
    var label = activeLabel;
    activeLabel = null;
    if (revertTimer) clearTimeout(revertTimer);
    revertTimer = setTimeout(function () {
      revertWithAnimation(label);
      revertTimer = null;
    }, REVERT_DELAY);
  }

  document.addEventListener('variant:add', function (event) {
    var form = event.target;
    if (!form || typeof form.querySelector !== 'function') return;

    var wrapper = form.querySelector('buy-buttons[data-oh-shipping]');
    if (!wrapper) return;

    var label = wrapper.querySelector('[data-oh-cta-label]');
    var cart = event.detail && event.detail.cart;
    if (!label || !cart) return;

    showMessage(label, messageFor(wrapper, cart));
  });

  // Drawer geschlossen -> nach 3 s Original-Text wiederherstellen
  document.addEventListener('dialog:after-hide', function (event) {
    var t = event.target;
    if (t && t.tagName === 'CART-DRAWER') scheduleRevert();
  });
})();
